import moment from "moment";
import styled, {css} from "styled-components";

const { endpoint } = require("../../common/constant");

export const groupCodeurl = endpoint.groupCode.getAllActive
export const companyCodeUrl = endpoint.companyCode.getAllActive
export const payModeCategoryUrl = endpoint.paymentMode.getAllActivePaymentCategory
export const getActiveProcessTagUrl = endpoint.process_Tag.getAllActive;
export const getAllActiveRoleUrl= endpoint.getRole.allActiveRoles

export const getLabelById = (value, item = []) => {
    return (item.find(item => item.value == value))?.label
}

export const getCreateReqBody=(rowForm)=>{
    return {
        "companyCode": rowForm?.value,
        "groupCode": rowForm?.groupCode?.value,
        "editMode": true,
        "paymentModeKey": rowForm?.paymentModeKey,
        "status": rowForm?.status || 'ACTIVE',
        "paymentModeDesc": rowForm?.paymentModeDesc,
        "paymentModeDispValue": rowForm?.paymentModeDispValue,
        "paymentCategory":rowForm?.paymentCategory?.value,
        "sapPaymode": rowForm?.sapPaymode,
        "paymodeSequence": rowForm?.paymodeSequence,
        "effectiveDate": rowForm?.effectiveDate,
        "paymodeType": rowForm?.paymodeType?.value,
        "groupCodeId": rowForm?.groupCodeId?.value,
        "companyCodeId": rowForm?.companyCodeId?.value
    }
}
export const findObjById=(id,dropdownList)=>{
    return dropdownList.find(item=>item?.value==id)
}
export const newRow={
    "companyCode": "",
    "groupCode": "",
    "editMode": "",
    "paymentModeKey": "",
    "status":  'ACTIVE',
    "paymentModeDesc": "",
    "paymentModeDispValue": "",
    "paymentCategory":"",
    "sapPaymode": "",
    "paymodeSequence": "",
    "effectiveDate": "",
    "paymodeType": "",
    "groupCodeId": "",
    "companyCodeId": "",
}
export const getUpdatedFilterRequest=(filterForm)=>{
  return{  
    'paymentMode':filterForm?.paymentMode,
    'paymentModeDesc':filterForm?.paymentModeDesc,
    "processTypeIds":filterForm?.processTag?filterForm?.processTag.map(item=>item.value):[],
    "roleIds":filterForm?.roles?filterForm?.roles.map(item=>item.value):[],
    "paymentCategories":filterForm?.paymentCategory?filterForm?.paymentCategory.map(item=>item.value):[],
    "paymentTypes":filterForm?.paymentType?filterForm?.paymentType.map(item=>item.value):[]
  }
}

export const initialFilterForm={
    processTag:[],
    roles:[],
    paymentCategory:[],
    paymentType:[]
}
export const searchInitialFilterForm={
    paymentMode:"",
    paymentModeDesc:""
}

export const searchInputParams = {
    paymentMode: {
      dispValue: "Paymode Code",
      placeholder: "Search paymode display value",
    },
  
    paymentModeDesc: {
      dispValue: "Description",
      placeholder: "Please paymode description",
    },
  };

  export const styles = {
    crossIconStyle: {
      fontSize: "11px",
      position: "absolute",
      top: "0.6rem",
      right: "30px",
      cursor: "pointer",
    },
  
    SeachWrapper: styled.span`
      svg {
        position: absolute;
        top: 5.5px;
        right: 5px;
        cursor: pointer;
        z-index: 3;
      }
    `,
  
    ErrorMsg: styled.div`
      color: #dc2804;
      margin-top: 5px;
      margin-left: 12px;
      font-size: 12px;
    `,
  
    StyledInput: styled.input`
      padding-left: 5px !important;
      width: 370px;
  
      ${(props) =>
        props.errorMsg &&
        props.searchInputValue?.trim()?.length <
          props.selectedSearchFieldProperties?.validLength &&
        props.searchInputValue?.trim()?.length > 0 &&
        css`
          border: 1px solid #dc2804;
          color: #dc2804;
          :hover:not([disabled]),
          :focus:not([disabled]) {
            border-color: #dc2804 !important;
            color: #dc2804 !important ;
          }
          &:not(:placeholder-shown) {
            color: #dc2804 !important;
          }
        `}
    `,
  };

  export const isFilterApplied=(form)=>{
    let count=0;
    const valueList=Object.values(form);
    for(let item in valueList){
        if(Array.isArray(valueList[item])&&valueList[item].length>0)
            count++
    }
    return count
  }